import React from 'react'

import Card from 'react-bootstrap/Card'
import Stack from 'react-bootstrap/Stack'
import Badge from 'react-bootstrap/Badge'

import './accessPassTemplatePreview.scss'

function formatSampleDate(event) {
  if (!event?.start) return 'Upcoming date'
  const date = new Date(event.start)
  if (Number.isNaN(date.getTime())) return 'Upcoming date'
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export function AccessPassTemplatePreview({
  name,
  backgroundColor,
  fontColor,
  primaryColor,
  artwork,
  eventCount = 0,
  sampleEvent,
}) {
  const displayName = name?.trim() || 'Access Pass'
  const remainingCount = Math.max(eventCount, 1)

  return (
    <div className="access-pass-template-preview">
      <p className="small text-muted mb-2">Pass preview</p>
      <Card className="access-pass-template-preview__card card-xl">
        <div
          className="access-pass-template-preview__header"
          style={{ backgroundColor, color: fontColor }}
        >
          <Stack direction="horizontal" className="align-items-start gap-3">
            {artwork && (
              <div className="access-pass-template-preview__header-artwork">
                <Card.Img src={artwork} alt={`Artwork for ${displayName}`} />
              </div>
            )}
            <Stack gap={0} className="flex-grow-1 min-w-0">
              <Stack
                direction="horizontal"
                className="align-items-start justify-content-between gap-3"
              >
                <div className="min-w-0">
                  <p className="caption--uppercase access-pass-template-preview__label mb-1">
                    All-access pass
                  </p>
                  <Card.Title as="h5" className="normal normal-bold mb-1">
                    {displayName}
                  </Card.Title>
                  <p className="small access-pass-template-preview__meta mb-0">
                    Pass #P-00000000
                  </p>
                </div>
                <div
                  className="access-pass-template-preview__qr"
                  style={{ borderColor: `${fontColor}33` }}
                >
                  <span style={{ color: fontColor, opacity: 0.7 }}>QR</span>
                </div>
              </Stack>
              <hr className="my-3" />
              <Stack
                direction="horizontal"
                className="justify-content-between gap-3"
              >
                <div>
                  <p className="caption access-pass-template-preview__label mb-0">
                    Events included
                  </p>
                  <p className="small normal-bold access-pass-template-preview__stat mb-0">
                    {remainingCount} of {remainingCount} remaining
                  </p>
                </div>
                <div className="text-end">
                  <p className="caption access-pass-template-preview__label mb-0">
                    Valid through
                  </p>
                  <p className="small normal-bold access-pass-template-preview__stat mb-0">
                    Dec 2026
                  </p>
                </div>
              </Stack>
            </Stack>
          </Stack>
        </div>

        <Card.Body className="access-pass-template-preview__body">
          {sampleEvent && (
            <div className="mb-4">
              <p className="access-pass-template-preview__section-label">
                Next up
              </p>
              <Card
                className="access-pass-template-preview__next-up m-0"
                style={{ borderColor: primaryColor }}
              >
                <Card.Body>
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="align-items-center"
                  >
                    <div className="access-pass-template-preview__event-thumb">
                      <div className="access-pass-template-preview__event-thumb-placeholder" />
                    </div>
                    <Stack gap={1} className="flex-grow-1 min-w-0">
                      <Card.Title
                        as="h6"
                        className="card-title-sm mb-0 text-truncate"
                      >
                        {sampleEvent.name}
                      </Card.Title>
                      <Card.Subtitle className="mb-0 small text-muted">
                        {formatSampleDate(sampleEvent)}
                      </Card.Subtitle>
                    </Stack>
                    <Badge
                      className="access-pass-template-preview__badge flex-shrink-0"
                      style={{
                        color: primaryColor,
                        backgroundColor: `${primaryColor}24`,
                        borderColor: `${primaryColor}59`,
                      }}
                    >
                      Upcoming
                    </Badge>
                  </Stack>
                </Card.Body>
              </Card>
            </div>
          )}

          {eventCount === 0 && (
            <p className="small text-muted mb-0">
              Select events to preview the event list.
            </p>
          )}
        </Card.Body>
      </Card>
    </div>
  )
}
